import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { DashboardService } from "../dashboard.service";
import { Subscription } from "rxjs/Subscription";
import { AppService } from "../../../app.service";
import { PreferencesService } from "../../preferences/preferences.service";
import { FleetReportConfigurationComponent } from "../fleet-report-configuration/fleet-report-configuration.component";
import { MatDialog } from "@angular/material/dialog";
import { PageEvent } from "@angular/material/paginator";
import { ConfigType } from "../../../../app/shared/enums/allEnums";
@Component({
  selector: "dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.style.scss"],
})
export class DashboardComponent implements OnInit, OnDestroy {
  routeLinks: any[] = [
    {
      label: "Fleet Overview",
      link: "/fleet",
    },
    {
      label: "Component Overview",
      link: "/components",
    },
    {
      label: "Wear Rate Overview",
      link: "/wears",
    },
    {
      label: "Shovel Overview",
      link: "/shovels",
    },
  ];

  activeLinkIndex = 1;
  exportButtonStatusSubscription: Subscription;
  _is_print_Subscription: Subscription;
  widgetTriggerSubscription: Subscription;
  _widgetsStatus = [
    { widget: "fleet-condition-widget", hiddenStatus: true },
    { widget: "inspections-performed-widget", hiddenStatus: true },
    { widget: "cost-of-repairs-monthly-widget", hiddenStatus: true },
    { widget: "components-on-eval-widget", hiddenStatus: true },
    { widget: "app-inspections-due-widget", hiddenStatus: true },
  ];
  //0 Means not show, 1 means fleet view, 2 means component view
  _exportStatus = 0;
  _print_version: boolean = false;
  isUCClick: boolean = false;
  isGETClick: boolean = false;
  constructor(
    private _router: Router,
    private _service: DashboardService,
    private _appService: AppService,
    private _route: ActivatedRoute,
    private readonly _pref: PreferencesService,
    private _dialog: MatDialog,
  ) {}

  ngOnInit() {
    let values = window.location.href;
    var IsGETCLickVal = values.includes("get/dashboard");
    let val = values.includes("/fleet/1");
    if (val == true) {
      this.isUCClick = true;
      this.isGETClick = false;
    } else {
      this.isUCClick = false;
    }

    if (IsGETCLickVal == true) {
      this.isUCClick = false;
      this.isGETClick = true;
    }

      if (this.isGETClick) {
        this._router.navigate(["/get/dashboard"]);
      } else {
        this._appService.GetDashboardDefaultView().subscribe((res: any) => {
          if (res != null) {
            this.activeLinkIndex = res;
            if (res == 0) {
              this._router.navigate(["/fleet", 1]);
            } else if (res == 1) {
              this._router.navigate(["/components", 1]);
            } else if (res == 2) {
              this._router.navigate(["/wears", 1]);
            } else if (res == 3) {
              this._router.navigate(["/get/dashboard"]);
            } else if (res == 4) {
              this._router.navigate(["/fecr/dashboard"]);
            } else if (res == 5) {
              this._router.navigate(["/safety/safetyhome"]);
            } else if (res == 6) {
              this._router.navigate(["/digitalform/search"]);
            } else if (res == 7) {
              this._router.navigate(["/shovels", 1]);
            }
          }
          else 
            this._router.navigate(["/fleet", 1]);
        });
      }
    

    this.exportButtonStatusSubscription = this._service
      .getExportStatus()
      .subscribe(
        (message) => {
          setTimeout(() => {
            this._exportStatus = message;
          }, 3);
        },
        (error) => console.error(error),
        () => {},
      );
    this._is_print_Subscription = this._service.getIsPrintSubject().subscribe(
      (m) => {
        setTimeout(() => {
          this._print_version = m;
        }, 4);
      },
      (error) => console.error(error),
      () => {},
    );
    this._appService.getSelectionSearchItems().subscribe(
      (items) => {
        setTimeout(() => {
          this._widgetsStatus.forEach((w) => {
            w.hiddenStatus = true;
          });
        }, 5);
      },
      (error) => console.error(error),
      () => {},
    );
    this.widgetTriggerSubscription = this._appService
      .getWidgetTrigger()
      .subscribe(
        (widget) => {
          let current = this._widgetsStatus.find((m) => m.widget == widget);
          if (current) current.hiddenStatus = false;
        },
        (error) => console.error(error),
        () => {},
      );

    // TT-1290

    //  if(this.isUCClick==false){
    //     if(this.isGETClick==true){
    //         this._router.navigate(['/get/dashboard']);
    //     }else{
    //         this._appService.GetDashboardDefaultView().subscribe((res: any) => {
    //             if (res != null) {
    //               //  console.log("res__dashboard", this.activeLinkIndex, res)
    //                 this.activeLinkIndex = res;

    //                 if (res == 0) {
    //                     this._router.navigate(['/fleet', 1]);
    //                 } else if (res == 1) {
    //                     // Already pointing to Component Overview
    //                     this._router.navigate(['/components', 1]);
    //                 } else if (res == 2) {
    //                     this._router.navigate(['/wears', 1]);
    //                 }

    //                 else if (res == 3) {
    //                     this._router.navigate(['/get/dashboard']);
    //                 }
    //                 else if (res == 4) {
    //                     this._router.navigate(['/fecr/dashboard']);
    //                 } else if (res == 5) {
    //                     this._router.navigate(['/safety/safetyhome']);
    //                 } else if (res == 6) {
    //                     this._router.navigate(['/digitalform/search']);
    //                 }
    //                 else if(res == 7){
    //                     this._router.navigate(['/shovels', 1]);
    //                 }
    //             }
    //         });
    //     }

    //  }else{
    //     this._router.navigate(['/fleet', 1]);
    //  }
  }

  openFleetReport() {
    this._dialog.open(FleetReportConfigurationComponent, {
      panelClass: "removeModalOverflow",
      maxHeight: "960px",
      autoFocus: false,
      disableClose: true,
      data: {
        RequestFromFlag: ConfigType.Fleet,
      },
    });
  }
  //checkDashboardView(view, routeLink): boolean {
  //    var result = false;

  //    if ((view == 0) && (routeLink.includes('/fleet'))) {
  //        result = true;
  //    } else if ((view == 1) && (routeLink.includes('/components'))) {
  //        result = true;
  //    } else if ((view == 2) && (routeLink.includes('/wears'))) {
  //        result = true;
  //    } else if (this.activeLinkIndex == view) {
  //        result = true;
  //    }

  //    return result;
  //}

  exportClicked(item: number) {
    this._service.sendExportClicked(item);
  }

  ngOnDestroy() {
    this.exportButtonStatusSubscription.unsubscribe();
    this._is_print_Subscription.unsubscribe();
  }

  hideStatus(widget: string): boolean {
    let current = this._widgetsStatus.find((m) => m.widget == widget);
    if (current) return current.hiddenStatus;
    return true;
  }

  componentPageChanged(event: PageEvent) {}

  fleetConditionChanged(event: PageEvent) {}

  navigateToSetupEquipment() {
    this._router.navigate(["setup-equipment"]);
    // this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    //     if(res=="True"){
    //       this._router.navigate(['/setup-equipment']);
    //     }else{
    //       window.open('/setup-equipment/', '_blank');

    //     }
    // });
  }
}
